<script setup>
  import { computed, inject } from 'vue'
  import Icon from "@/components/icons/Icon.vue";
  import ProductLockedIcon from "@/components/icons/ProductLockedIcon.vue";
  const model = defineModel();

  const props = defineProps({
    name: {
      type: String,
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      required: false
    }
  });

  // Provided by ToggleList
  const elementType = inject('elementType');

</script>

<template>
  <component :is="!elementType || elementType === 'div' ? 'div' : 'li'" class="jwx-toggle jwx-toggle--upgrade">
    <div :class="['jwx-toggle-upgrade', {'jwx-toggle-upgrade--disabled': isDisabled }]">
      <Icon v-if="iconName" :name="iconName" class="jwx-toggle-upgrade-icon" />
      <span class="jwx-toggle-upgrade-text">
        <slot></slot>
      </span>
      <ProductLockedIcon />
    </div>
  </component>
</template>